import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { QueryParamsEntitiesV3, TableErrorResponse } from "./MainApp";
import { PaginationV2 } from "./Pagination";
import { AccountController } from '@/app/ui/controllers/AccountController';

// GET LIST OF LOGIN APPROVAL

export class LoginApproval {
  accountName = "";
  roleName = "";
  deviceApprovalId = "";
  deviceName = "";
  deviceOs = "";
  lastActiveAt = "";
  createdAt = "";
  lastLocationLogin = "";
  approvalStatus = "";
  pairingCode = "";
  deviceIdApproval = "";
  expiredData = "";

  constructor(fields?: Partial<LoginApproval>) {
    Object.assign(this, fields);
  }
}

export class LoginApprovalRequest {
  query = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<LoginApprovalRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
      })
    ).queryString;
  }
}

export class LoginApprovalList {
  data: LoginApproval[] = [];
  pagination = new PaginationV2();
  loading = false;
  error = new TableErrorResponse();
  params = new LoginApprovalRequest();

  constructor(fields?: Partial<LoginApprovalList>) {
    Object.assign(this, fields);

    if (fields?.pagination) {
      this.pagination = new PaginationV2(fields.pagination);
    }

    if (fields?.data) {
      this.data = fields.data.map((item: LoginApproval) => new LoginApproval(item));
    }
  }
}

// POST REQUEST LOGIN DEVICE

export class LoginReviewBody {
  deviceApprovalId = "";
  reviewType = "";
  deviceIdApproval = "";

  constructor(fields?: Partial<LoginReviewBody>) {
    Object.assign(this, fields);
  }

  toJSON() {
    const payload = ConvertObjectCamelToSnakeCaseV2(this);
    delete payload.device_id_approval;
    return payload;
  }
}

export class LoginReviewSuccess {
  message = "";

  constructor(fields?: Partial<LoginReviewSuccess>) {
    Object.assign(this, fields);
  }
}

export class LoginReviewError {
  code = 0;
  message = {
    en: "",
    id: "",
  };

  constructor(fields?: Partial<LoginReviewError>) {
    Object.assign(this, fields);
  }
}

// APPROVED DEVICES

export class LoginApprovalDevice {
  accountName = "";
  roleName = "";
  deviceAuthId = "";
  deviceName = "";
  deviceOs = "";
  lastActiveAt = "";
  approvedAt = "";
  pairingCode = "";
  lastLocationLogin = "";

  constructor(fields?: Partial<LoginApprovalDevice>) {
    Object.assign(this, fields);
  }
}

export class LoginApprovalDeviceRequest {
  query = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<LoginApprovalDeviceRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
      })
    ).queryString;
  }
}

export class LoginApprovalDevicesList {
  data: LoginApprovalDevice[] = [];
  pagination = new PaginationV2();
  loading = false;
  error = new TableErrorResponse();
  params = new LoginApprovalDeviceRequest();

  constructor(fields?: Partial<LoginApprovalDevicesList>) {
    Object.assign(this, fields);

    if (fields?.pagination) {
      this.pagination = new PaginationV2(fields.pagination);
    }

    if (fields?.data) {
      this.data = fields.data.map((item: LoginApprovalDevice) => new LoginApprovalDevice(item));
    }
  }
}

// POST DELETE APPROVED DEVICE

export class LoginApprovalDeleteReviewBody {
  deviceAuthId = "";

  constructor(fields?: Partial<LoginApprovalDeleteReviewBody>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return ConvertObjectCamelToSnakeCaseV2(this);
  }
}

export class LoginApprovalDeleteReviewSuccess {
  message = "";

  constructor(fields?: Partial<LoginApprovalDeleteReviewSuccess>) {
    Object.assign(this, fields);
  }
}

export class LoginApprovalDeleteReviewError {
  code = 0;
  message = {
    en: "",
    id: "",
  };

  constructor(fields?: Partial<LoginApprovalDeleteReviewError>) {
    Object.assign(this, fields);
  }
}

// HISTORY OF THE DEIVCES

export class LoginApprovalHistory {
  accountName = "";
  roleName = "";
  deviceApprovalId = ""; 
  deviceName = "";
  deviceOs = "";
  lastActiveAt = "";
  lastLocationLogin = "";
  approvalStatus = "";
  createdBy = "";
  createdAt = "";
  pairingCode = "";
  approvedAt = "";

  constructor(fields?: Partial<LoginApprovalHistory>) {
    Object.assign(this, fields);
  }
}

export class LoginApprovalHistoryRequest {
  query = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<LoginApprovalHistoryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
      })
    ).queryString;
  }
}

export class LoginApprovalHistoryList {
  data: LoginApprovalHistory[] = [];
  pagination = new PaginationV2();
  loading = false;
  error = new TableErrorResponse();
  params = new LoginApprovalHistoryRequest();

  constructor(fields?: Partial<LoginApprovalHistoryList>) {
    Object.assign(this, fields);

    if (fields?.pagination) {
      this.pagination = new PaginationV2(fields.pagination);
    }

    if (fields?.data) {
      this.data = fields.data.map((item: LoginApprovalHistory) => new LoginApprovalHistory(item));
    }
  }
}
